<template>
    <v-main>
      <div id="app">
        <v-app> 
          <Timeline v-if="$store.state.showTimeline"></Timeline>
          <Profile v-if="$store.state.showProfile" :person="$store.state.currPerson" @updatePerson="switchProfile"></Profile>
          <YearDetail v-if="$store.state.showYearDetail" :year="$store.state.currYear"></YearDetail>
          <Glossary v-if="$store.state.showGlossary"></Glossary>
          <PrimarySource v-if="$store.state.showPrimarySource" :source="$store.state.currSource" :link="$store.state.currSourceLink" :id="$store.state.currSourceId"></PrimarySource>
          <Map v-if="$store.state.showMap" :year="$store.state.mapYear" :id="$store.state.mapEventId"></Map>
        </v-app> 
      </div>
    </v-main>
</template>

<script>
  import Timeline from './components/Timeline';
  import Profile from './components/Profile';
  import YearDetail from './components/YearDetail';
  import Glossary from './components/Glossary';
  import PrimarySource from './components/PrimarySource';
  import Map from './components/Map';

  export default {
    name: 'App',

    components:{
      Profile, 
      YearDetail,
      Timeline,
      Glossary,
      PrimarySource,
      Map
    },

    created () {
    },

    methods: {
      switchProfile(newPerson){
        this.$store.state.currPerson = newPerson;
      },
    },
    data() {
      return{
      }
    }
  }
</script>

<style lang="scss">

</style>
